import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { magazines } from "../../utils/magazine";
import { mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";

export default function MagazineReaderPage() {
  const { slug } = useParams<{ slug: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const MOBILE_BREAKPOINT = 805;
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT

  );

  const magazine = magazines.find(
    (item) => item.slug === slug
  );
  useEffect(() => {
    if (!magazine) {
      return;
    }
    document.title = magazine.title;
    return () => {
      document.title = "Golden Destinations";
    };
  }, [magazine]);
  if (!magazine) {
    return (
      <main className="magazine-reader-page">
        <div className="magazine-reader-page__not-found">
          <h1>Magazine not found</h1>
          <p>
            Sorry, we couldn't find the magazine issue you're looking for.
          </p>
          <Link to="/web/magazine">
            Back to all magazines
          </Link>
        </div>
      </main>
    );
  }
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);


  return (
    <main className="magazine-reader-page">
      <div className="magazine-reader-page__container">
        <div className="magazine-reader-page__nav">
          {!isMobile ? (
            <Link to="/web/magazine" className="magazine-reader-page__back">
              <img className="magazine-reader-page__back__icon"
                src="/iceholidays-assets/images/icons/arrow-left.png"
                alt=""
              />
              Back
            </Link>
          ) : (
            < nav
              className="magazine-reader-page__breadcrumbs"
              aria-label="Breadcrumb"
            >
              <Link to="/web/magazine">Magazines</Link>
              <Icon path={mdiChevronRight} size="16px" />
              <span>Magazine Details</span>
            </nav>)}
        </div>
        <header className="magazine-reader-page__header">
          {magazine.isLatest && (<div className="magazine-reader-page__header__latest-issue">Latest Issue</div>)}
          <h1>{magazine.title}</h1>
          <p className="magazine-reader-page__header__details">
            Step into autumn’s most inspiring destinations. Discover seasonal
            escapes, thoughtful travel stories, and fresh perspectives from
            around the world.
          </p>
          <p className="magazine-reader-page__header__date">
            {new Date(magazine.publishedAt).toLocaleDateString(
              "en-GB",
              {
                day: "2-digit",
                month: "short",
                year: "numeric",
              }
            )}
          </p>
        </header>
        <section className="magazine-reader-page__viewer">
          {isMobile ? (
            <div className="magazine-reader-page__mobile">
              <img
                src={magazine.coverImage}
                alt={magazine.title}
              />
              <p>
                For the best reading experience, open the magazine
                in a new tab.
              </p>
              <a
                href={magazine.embedUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Open magazine
              </a>
            </div>
          ) : (
            <>
              {isLoading && !hasError && !isMobile && (
                <div className="magazine-reader-page__loading">
                  <span>Loading magazine...</span>
                </div>
              )}
              {hasError ? (
                <div className="magazine-reader-page__error">
                  <img
                    src={magazine.coverImage}
                    alt={magazine.title}
                  />
                  <h2>Unable to load the magazine</h2>
                  <p>
                    The magazine could not be loaded here. You can open
                    it in a new tab instead.
                  </p>
                  <a
                    href={magazine.embedUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Open magazine
                  </a>
                </div>
              ) : (
                <iframe
                  src={magazine.embedUrl}
                  title={magazine.title}
                  allow="fullscreen"
                  allowFullScreen
                  onLoad={() => {
                    setIsLoading(false);
                  }}
                  onError={() => {
                    setIsLoading(false);
                    setHasError(true);
                  }}
                />
              )}
            </>
          )}
        </section>
      </div>
    </main >
  );
}